import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LegacyPreferenceStorageService {
  readString(key: string, fallback = ''): string {
    const localStorageValue = localStorage.getItem(key);

    if (localStorageValue !== null) {
      return localStorageValue;
    }

    const cookieValue = this.readCookieValue(key);
    return cookieValue ?? fallback;
  }

  readBoolean(key: string, fallback = false): boolean {
    const value = this.readString(key, fallback ? 'true' : 'false');
    return value === 'true' || value === '1';
  }

  readNumber(key: string, fallback = 0): number {
    const value = Number(this.readString(key, `${fallback}`));
    return Number.isFinite(value) ? value : fallback;
  }

  readJson<T>(key: string, fallback: T): T {
    const rawValue = this.readString(key, '');

    if (!rawValue) {
      return fallback;
    }

    try {
      return JSON.parse(rawValue) as T;
    } catch {
      return fallback;
    }
  }

  writeString(key: string, value: string): void {
    localStorage.setItem(key, value);
    document.cookie = `${key}=${encodeURIComponent(value)}; path=/`;
  }

  writeBoolean(key: string, value: boolean): void {
    this.writeString(key, value ? 'true' : 'false');
  }

  writeJson(key: string, value: unknown): void {
    this.writeString(key, JSON.stringify(value));
  }

  private readCookieValue(key: string): string | null {
    const cookieEntries = document.cookie
      .split(';')
      .map((entry) => entry.trim())
      .filter(Boolean);

    for (const entry of cookieEntries) {
      if (entry.startsWith(`${key}=`)) {
        return decodeURIComponent(entry.slice(key.length + 1));
      }
    }

    return null;
  }
}
